import BISForm from './bis-form';

export default {
  props: ['productId', 'variants', 'options'],

  delimiters: ['#{', '}'],
  components: {
    'bis-form': BISForm,
  },
  data: function() {
    return {
      open: false
    }
  },

  methods: {
    close() {
    }
  },

  computed: {

  },
  template:
    `
      <div>
        <i class='cursor-pointer'><u @click='open = true'>Join the Waitlist</u></i>
        <div class='absolute text-sm md:text-md text-black left-0 bottom-0 right-0 bg-cream p-4 z-10 duration-300' :class="{ 'translate-y-full': !open }">
          <bis-form @close='open = false'  :product-id=productId :options=options :variants=variants></bis-form>
        </div>
      </div>

    `

}
